import { render, staticRenderFns } from "./TasksKanbanView.vue?vue&type=template&id=14c59308&scoped=true"
import script from "./TasksKanbanView.vue?vue&type=script&lang=js"
export * from "./TasksKanbanView.vue?vue&type=script&lang=js"
import style0 from "./TasksKanbanView.vue?vue&type=style&index=0&id=14c59308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c59308",
  null
  
)

export default component.exports